"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HishasHarmonyAbilityHandler = exports.HishasHarmonyActorAbilityFactory = exports.HishasHarmonyAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class HishasHarmonyAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.HishasHarmony;
        this.__typeName = "HishasHarmony";
    }
}
exports.HishasHarmonyAbilityArgs = HishasHarmonyAbilityArgs;
let HishasHarmonyActorAbilityFactory = class HishasHarmonyActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("HishasHarmony", "AllEnemies", 0);
    }
};
HishasHarmonyActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("HishasHarmony")
], HishasHarmonyActorAbilityFactory);
exports.HishasHarmonyActorAbilityFactory = HishasHarmonyActorAbilityFactory;
let HishasHarmonyAbilityHandler = class HishasHarmonyAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            supernatural: true,
            effect: new core_1.PassiveBuffEffectArgs("Hisha's Harmony", "Increases the damage of all allies by 15%", new core_1.DamageAmplifyEffectArgs(15)),
            onApplied: sequence => {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(actorId, "head", "front"), 
                // TODO: use a different animation (maybe some music notes?)
                "BeamFromTheHeavens", true));
            }
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
HishasHarmonyAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.HishasHarmony)
], HishasHarmonyAbilityHandler);
exports.HishasHarmonyAbilityHandler = HishasHarmonyAbilityHandler;
